import moment from "moment";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import API from "../../common/API";
import Settings from "../../common/Settings";
import { buildRecordPath } from "../../common/recordIdentifier";

const RecordEstructura = (props: any) => {
    const { id } = props;
    const [records, setRecords] = useState<any>([]);
    const [habilitarEnlaces, setHabilitarEnlaces] = useState<boolean>(false);
    const { t } = useTranslation();

    const bindRecords = async () => {
        try {
            const response = await API.getAction(`estructura/miembro?id=${id}`);
            if (response.status === 200) {
                setRecords(response.data.response || []);
            } else {
                console.error("Error fetching estructura records:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching estructura records:", error);
        }
    }

    useEffect(() => {
        if (id) {

            bindRecords();
        }
    }, [id]);
    if (records.length === 0) {
        return null;
    }

    return (<>
        {records.map((item, index) => {
            return (<Card className="my-4" key={index}>
                <Card.Header>
                    <Row>
                        {item.fotoCaso && <Col className="col-auto">
                            <a href={item.fotoCaso.includes("base64")
                                ? item.fotoCaso
                                : item.fotoCaso.includes("/")
                                    ? `${Settings.BasePath}/${item.fotoCaso}`
                                    : `${Settings.BasePath}/files/${item.fotoCaso}`} target="_blank" rel="noopener noreferrer">
                                <img
                                    alt=""
                                    loading="lazy"
                                    className=" img-thumbnail "
                                    style={{
                                        width: "100px",
                                        height: "100px",
                                        objectFit: "cover",
                                    }}
                                    id={"image" + index}
                                    src={
                                        item.fotoCaso.includes("base64")
                                            ? item.fotoCaso
                                            : item.fotoCaso.includes("/")
                                                ? `${Settings.BasePath}/${item.fotoCaso}`
                                                : `${Settings.BasePath}/files/${item.fotoCaso}`
                                    }
                                />
                            </a>
                        </Col>}
                        <Col className=" ">
                            <h3>{item.nombre}</h3>
                            {/* Check to add all the links that it has */}
                            {item.enlace1 && <a
                                href={habilitarEnlaces ? item.enlace1 : undefined}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`btn btn-primary btn-sm text-decoration-none ${!habilitarEnlaces ? 'disabled' : ''}`}
                                onClick={(e) => !habilitarEnlaces && e.preventDefault()}
                                style={!habilitarEnlaces ? { pointerEvents: 'none', opacity: 0.6 } : {}}
                            >
                                <i className="fas fa-link"></i> {t("Enlace 1")}
                            </a>}
                            {item.enlace2 && <a
                                href={habilitarEnlaces ? item.enlace2 : undefined}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`btn btn-primary btn-sm text-decoration-none ms-2 ${!habilitarEnlaces ? 'disabled' : ''}`}
                                onClick={(e) => !habilitarEnlaces && e.preventDefault()}
                                style={!habilitarEnlaces ? { pointerEvents: 'none', opacity: 0.6 } : {}}
                            >
                                <i className="fas fa-link"></i> {t("Enlace 2")}
                            </a>}
                            {item.enlace3 && <a
                                href={habilitarEnlaces ? item.enlace3 : undefined}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`btn btn-primary btn-sm text-decoration-none ms-2 ${!habilitarEnlaces ? 'disabled' : ''}`}
                                onClick={(e) => !habilitarEnlaces && e.preventDefault()}
                                style={!habilitarEnlaces ? { pointerEvents: 'none', opacity: 0.6 } : {}}
                            >
                                <i className="fas fa-link"></i> {t("Enlace 3")}
                            </a>}
                            {item.enlace4 && <a
                                href={habilitarEnlaces ? item.enlace4 : undefined}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`btn btn-primary btn-sm text-decoration-none ms-2 ${!habilitarEnlaces ? 'disabled' : ''}`}
                                onClick={(e) => !habilitarEnlaces && e.preventDefault()}
                                style={!habilitarEnlaces ? { pointerEvents: 'none', opacity: 0.6 } : {}}
                            >
                                <i className="fas fa-link"></i> {t("Enlace 4")}
                            </a>}
                            {item.enlace5 && <a
                                href={habilitarEnlaces ? item.enlace5 : undefined}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`btn btn-primary btn-sm text-decoration-none ms-2 ${!habilitarEnlaces ? 'disabled' : ''}`}
                                onClick={(e) => !habilitarEnlaces && e.preventDefault()}
                                style={!habilitarEnlaces ? { pointerEvents: 'none', opacity: 0.6 } : {}}
                            >
                                <i className="fas fa-link"></i> {t("Enlace 5")}
                            </a>}
                            {item.enlaceRasadep && <a
                                href={item.enlaceRasadep}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`btn btn-primary btn-sm text-decoration-none ms-2`}
                            // onClick={(e) => !habilitarEnlaces && e.preventDefault()}
                            // style={!habilitarEnlaces ? { pointerEvents: 'none', opacity: 0.6 } : {}}/
                            >
                                <i className="fas fa-link"></i> {t("Enlace RASADEP")}
                            </a>}
                        </Col>
                    </Row>


                </Card.Header>
                <Card.Body className="p-0">
                    <Row>
                        <Col xs={12}>
                            <div className="table-responsive">
                                <table className="table table-striped shadow-md border">
                                    <thead>
                                        <tr>
                                            <th colSpan={3}>{t("PADEP")}</th>
                                        </tr>
                                        <tr>

                                            <th>Img</th>

                                            <th>{t("Nombre")}</th>
                                            <th className="text-end">{t("Informe")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {item.miembros && item.miembros.map((member, index) => {
                                            return <tr key={index}>
                                                <td>
                                                    {member.fotoCedula &&
                                                        <a href={`${Settings.BasePath}${(member.fotoCedula.includes("/")) ? "" : "files/"}${member.fotoCedula}`} target="_blank" rel="noopener noreferrer">
                                                            <img
                                                                src={`${Settings.BasePath}${(member.fotoCedula.includes("/")) ? "" : "files/"}${member.fotoCedula}`}
                                                                alt="Foto"


                                                                style={{ width: "100px", height: "100px", objectFit: "cover" }}
                                                            />
                                                        </a>}
                                                </td>

                                                <td>
                                                    <b>Nombre:</b>&nbsp;{member.nombres} {member.primerApellido} {member.segundoApellido}
                                                    {member.noCasos > 1 && <i className="fas fa-diagram-project text-danger ms-2" title={t("Multiple casos") ?? ""}></i>}

                                                    <br />
                                                    <b>Cédula:</b>&nbsp;{member.identificador}
                                                    <br />
                                                    <b>Alias:&nbsp;</b>{member.alias} {member.alias2}
                                                    <br />
                                                    <b>Vinculo:&nbsp;</b>{member.vinculo}

                                                </td>
                                                <td className="text-end">
                                                    {member.identificador &&
                                                        <a href={buildRecordPath(member.identificador)} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-primary">
                                                            {t("Ver Informe")}
                                                        </a>}
                                                </td>
                                            </tr>
                                        }
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                        {item.victimas && item.victimas.length > 0 &&
                            <Col xs={12}>
                                <div className="table-responsive shadow-md border">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th colSpan={3}><h3>{t("VICTIMA (S)")}</h3></th>
                                            </tr>
                                            <tr>

                                                <th>Img</th>

                                                <th>{t("Nombre")}</th>
                                                <th className="text-end">{t("Informe")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {item.victimas && item.victimas.map((victim, index) => {
                                                return <tr key={index}>
                                                    <td>
                                                        {victim.fotoCedula &&
                                                            <a href={`${Settings.BasePath}${(victim.fotoCedula.includes("/")) ? "" : "files/"}${victim.fotoCedula}`} target="_blank" rel="noopener noreferrer">
                                                                <img
                                                                    src={`${Settings.BasePath}${(victim.fotoCedula.includes("/")) ? "" : "files/"}${victim.fotoCedula}`}
                                                                    alt="Foto"
                                                                    className="img-thumbnail "
                                                                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                                                                />
                                                            </a>}
                                                    </td>
                                                    <td>
                                                        <b>{victim.nombres} {victim.primerApellido} {victim.segundoApellido}
                                                            {victim.noCasos > 1 && <i className="fas fa-diagram-project text-danger ms-2" title={t("Multiple casos") ?? ""}></i>}
                                                        </b>
                                                        <br />
                                                        {victim.identificador}
                                                        {victim.vinculo && <>
                                                            <br />
                                                            <b>Vinculo:&nbsp;</b>{victim.vinculo}
                                                        </>}

                                                    </td>
                                                    <td className="text-end">
                                                        {victim.identificador &&
                                                            <a href={buildRecordPath(victim.identificador)} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-primary">
                                                                {t("Ver Informe")}
                                                            </a>}
                                                    </td>
                                                </tr>
                                            }
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </Col>}

                        {item.companias && item.companias.length > 0 &&
                            <Col xs={12}>
                                <div className="table-responsive shadow-md border">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th colSpan={3}><h3>{t("EMPRESAS IMPLICADAS / RASADEP")}</h3></th>
                                            </tr>
                                            <tr>

                                                <th>{t("RNC/Identificador")}</th>

                                                <th>{t("Nombre / Razón Social")}</th>
                                                <th className="text-end">{t("Informe")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {item.companias && item.companias.map((compania, index) => {
                                                return <tr key={index}>
                                                    <td className="text-danger">
                                                        {compania.identificador}
                                                    </td>
                                                    <td className="text-danger">
                                                        <b>{compania.nombre}</b>
                                                    </td>

                                                    <td className="text-end">
                                                        {props.id !== compania.identificador &&
                                                            <a
                                                                href={buildRecordPath(compania.identificador)}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className={`btn btn-sm btn-primary`}
                                                            // onClick={(e) => !habilitarEnlaces && e.preventDefault()}
                                                            >
                                                                {t("Ver Informe")}
                                                            </a>}
                                                    </td>
                                                </tr>
                                            }
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </Col>}
                    </Row>
                </Card.Body>
            </Card>)
        })}

    </>
    );
};

export default RecordEstructura
